import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../../common/TitleSection';
import styles from "../../../../ContentStyling.module.css";

const CmToMeters = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToMeters = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 100, 250.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const meterValue = cmValue / 100; // 1 meter = 100 cm
        setOutputValue(meterValue.toFixed(6)); // Limit output to 6 decimal places
    };




      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/meters-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to Meter Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to meters using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
        icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
        title="CM To Meter Converter"
        subTitle="Effortlessly Convert CM To Meter for Accurate Measurements"
      />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToMeters}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Meter Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For students, engineers, architects, and everyday users, the CM to Meters Converter is a practical tool that simplifies the process of converting centimeters (CM) to meters (M). Whether you’re drafting technical plans, solving math problems, or measuring space, this converter ensures quick and accurate results every time.</p>
      <p>This tool helps bridge smaller measurements with standard units used in construction, design, and science.</p>
      <h3>What Are CM and Meters?</h3>
      <p><b>Centimeters (CM): </b>A commonly used unit in the metric system, suitable for measuring smaller lengths or objects.
      <br />1 centimeter = 0.01 meters.</p>
      <p><b>Meters (M): </b> A standard unit of length in the metric system used for larger measurements.
      <br />1 meter = 100 centimeters.</p>
      <h3>Why Convert CM to Meters?</h3>
      <ul>
        <li><b>Standard Usage:</b> Meters are the standard unit in engineering, construction, and most metric-based systems.</li>
        <li><b>Accuracy:</b> Provides clarity when working with blueprints, floor plans, or dimensioned drawings.</li>
        <li><b>Convenience:</b> Long centimeter values can be simplified into meters for better readability.</li>
      </ul>
      <h3>How to Use the CM to Meters Converter</h3>
      <ol>
        <li><b>Input CM Value:</b> Type the number of centimeters in the input field.</li>
        <li><b>Click Convert:</b> The tool will immediately calculate and show the value in meters.</li>
        <li><b>Copy & Use:</b> Use the converted value for your design files, academic work, or building specs.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 cm → 0.01 m</li>
        <li>50 cm → 0.5 m</li>
        <li>100 cm → 1 m</li>
        <li>250 cm → 2.5 m</li>
      </ul>
      <h3>Benefits of Using CM to Meters Converter</h3>
      <ul>
        <li><b>Quick and Easy:</b> Converts units instantly without manual calculation.</li>
        <li><b>Accurate:</b> Delivers results based on the precise metric formula.</li>
        <li><b>User-Friendly:</b> Designed for users of all levels no technical background needed.</li>
      </ul>
      <h3>Why Choose This CM to Meters Converter?</h3>
      <p>Whether you’re laying out room dimensions, teaching metric conversions, or verifying measurements for a product, this tool is built for ease and accuracy. Perfect for:</p>
      <ul>
        <li><b>Students & Teachers:</b> For education, homework, and learning unit conversions.</li>
        <li><b>Construction Professionals:</b> To convert plans, site measurements, and specs.</li>
        <li><b>Interior Designers & Architects:</b> For precise scaling and layout planning.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToMeters;
